import React,{useState} from 'react';
import { App, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './YourTownloopOrdersListService.module.scss';
import { saveToCart } from '@/api/cart';
import { saveServiceOrderDelete, saveServiceOrderCancel ,saveServiceOrderComplete} from '@/api/order';
import { OrderData, TransformedOrder } from '../../Subroute/ServiceOrders/order';
import { useTranslation } from 'react-i18next';


interface YourTownloopOrdersListProps {
  orders: TransformedOrder[];
  getId?: (id: string, action: string) => void;
}

const YourTownloopOrdersList: React.FC<YourTownloopOrdersListProps> = ({ orders, getId }) => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [selectedOrder, setSelectedOrder] = useState<TransformedOrder | null>(null);

  const [orderDetailsModalVisible, setOrderDetailsModalVisible] = useState(false);

  // Buy Now 方法 - 类似ProductDetail中的OrderDetails
  const OrderDetails = (order: any) => {
    console.log(order, 'orderorderorderorder');

    setSelectedOrder(order);
    setOrderDetailsModalVisible(true);

    // 传递订单ID用于获取订单详情 - 使用btoa编码
    // const encodedOrderId = btoa(order.product_order_id);
    // navigate(`/ServicePlaceOrder?orderId=${encodedOrderId}`);
  };

  // 删除订单确认
  const handleDeleteOrder = (order: TransformedOrder) => {
    Modal.confirm({
      title: 'Confirm Delete Order',
      content: `Are you sure you want to delete order ${order.id}? This action cannot be undone.`,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const params = {
            service_order_id: order.id
          };

          const res = await saveServiceOrderDelete(params);
          if (res.code === 200) {
            message.success('Order deleted successfully');
            // 调用父组件的删除方法，用于刷新列表
            getId && getId(order.id, 'delete');
          } else {
            message.error(res.message || 'Delete failed');
          }
        } catch (error) {
          console.error('Delete order failed:', error);
          message.error('Delete failed, please try again');
        }
      },
    });
  };

  // 取消订单确认
  const handleOrderCancelled = (order: TransformedOrder) => {
    Modal.confirm({
      title: '{t("YourTownloopOrdersList.ConfirmCancelOrder")}',
      content: `{t("YourTownloopOrdersList.WantCancelOrder")} ${order.id}? {t("YourTownloopOrdersList.Thisactioncannotbeundone")}`,
      okText: '{t("YourTownloopOrdersList.CancelOrder")}',
      okType: 'danger',
      cancelText: '{t("YourTownloopOrdersList.ON")}',
      onOk: async () => {
        try {
          const params = {
            service_order_id: order.id
          };

          const res = await saveServiceOrderCancel(params);
          if (res.code === 200) {
            message.success('Order cancelled successfully');
            // 用于刷新列表
            getId && getId(order.id, 'cancel');
          } else {
            message.error(res.message || 'Cancel order failed');
          }
        } catch (error) {
          message.error('Cancel order failed, please try again');
        }
      }
    });
  };

  const handleConfirmService = (order: TransformedOrder) => {
    Modal.confirm({
      title: 'Confirm Complete Order',
      content: `Are you sure you want to complete order ${order.id}? This action cannot be undone.`,
      okText: 'Complete Order',
      // okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        try {
          const params = {
            order_id: order.odId
          };

          const res = await saveServiceOrderComplete(params);
          if (res.code === 200) {
            message.success('Order completed successfully');
            // 用于刷新列表
            getId && getId(order.id, 'complete');
          } else {
            message.error(res.message || 'Complete order failed');
          }
        } catch (error) {
          console.error('Complete order failed:', error);
          message.error('Complete order failed, please try again');
        }
      }
    });
  };

  return (
    <div className={styles['orders-list-wrapper']}>
      {/* 表头 */}
      <div className={styles['orders-list-header']}>
        <div className={styles['header-info']}>{t('YourTownloopOrdersList.OrderInformation')}</div>
        <div className={styles['header-amount']}>{t('YourTownloopOrdersList.GoodsAmount')}</div>
        <div className={styles['header-paid']}>{t('YourTownloopOrdersList.PaidAmount')}</div>
        <div className={styles['header-handle']}>{t('YourTownloopOrdersList.OrderHandling')}</div>
      </div>
      {orders.map(order => (
        <div className={styles['order-block']} key={order.id}>
          {/* 订单头部 */}
          <div className={styles['order-header']}>
            <div className={styles['order-header-left']}>
              <span className={styles['order-date']}>{order.date}</span>
              <span className={styles['order-number']}>{t('YourTownloopOrdersList.OrderNumber')}:{order.orderNumber}</span>

            </div>
            <div className={styles['order-header-right']}>
              <span className={styles['order-status']}>{order.status}</span>
            </div>
          </div>




          {/* 商品信息区块 */}
          {order.products.map((product, index) => (
            <div className={styles['order-body']} key={index}>
              <div className={styles['order-product-info']}>
                <img className={styles['product-img']} 
                onClick={() => navigate(`/ServiceProductDetail/${product?.product_id}`)} 
                src={product?.img} alt={product?.title} />
                <div className={styles['product-detail']}>
                  <div className={styles['product-title']} title={product?.title}>
                    {product?.title}({product?.specs?.name})
                    
                  </div>
                  <div className={styles['product-refund']}>{t('Cart.FastRefunds')}</div>
                </div>
              </div>
              <div className={styles['order-price-info']}>
                <div className={styles['product-price']}>${product?.price}</div>
                <div className={styles['product-quantity']}>×{product?.quantity}</div>
                {order.products.length > 1 && (
                  <div className={styles['total-products']}>
                    {t('common.Total')}: {order.products.length} {t('common.items')}
                  </div>
                )}
              </div>
              <div className={styles['order-paid-info']}>
                <div className={styles['paid-label-box']}>
                  <div className={styles['paid-label']}>paid amount</div>
                  <div className={styles['paid-amount']}>${product.subtotalPrice}</div>
                </div>
                
              </div>
              <div className={styles['order-actions']}>

              {(order.order_status === 1) && (
                  <button
                    className={styles['repeat-btn']}
                    onClick={() => handleConfirmService(order)}
                  >
                    {t('YourTownloopOrdersListService.ConfirmService')}
                  </button>
                )}

                {(order.order_status === -1 || order.order_status === 2) && (
                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleDeleteOrder(order)}
                  >
                    {t('common.Delete')}
                  </button>
                )}
                {(order.order_status === 0) && (
                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleOrderCancelled(order)}
                  >
                    {t('common.Cancel')}
                  </button>
                )}

                <button
                  className={styles['repeat-cart']}
                  onClick={() => OrderDetails(order)}
                >{t("YourTownloopOrdersListService.Details")}</button>


              </div>
            </div>
          ))}


          {/* 商品信息区块 */}






        </div>
      ))}


      {/* 订单详情弹出框 */}
      <Modal
        title={
          <div style={{
            fontWeight: 'bold',
            fontSize: '24px',
            color: '#0D323E',
            lineHeight: '34px'
          }}>
            {t('YourTownloopOrdersListService.OrderDetails')}
          </div>
        }
        open={orderDetailsModalVisible}
        onCancel={() => setOrderDetailsModalVisible(false)}
        footer={null}
        width={800}
        className={styles['order-details-modal']}
      >

        {selectedOrder && (
          <div className={styles['order-details-content']}>
            {/* 位置和距离信息 */}
            <div className={styles['location-section']}>
              <div className={styles['location-left']}>
                <img
                  className={styles['product-img']}
                  src={selectedOrder?.products[0]?.img}

                />
              </div>
              <div className={styles['location-right']}>
                <div className={styles['location-item']}>
                  {selectedOrder?.products[0]?.title}
                </div>
               
                <div className={styles['location-description']}>
                  <span className={styles['location-description-value']} >
                  {selectedOrder?.products[0]?.specs?.name}
                  </span>
                </div>
              </div>
            </div>

            {/* 订单信息 */}
            <div className={styles['order-info-section']}>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>{t('YourTownloopOrdersList.OrderNumber')}:</span>
                <span className={styles['info-value']}>{selectedOrder?.orderNumber || ''}</span>
              </div>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>{t('YourTownloopOrdersList.OrderStatus')}:</span>
                <span className={styles['info-value']}>{selectedOrder?.status || ''}</span>
              </div>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>{t('YourTownloopOrdersList.GoodsAmount')}:</span>
                <span className={styles['info-value']}>${selectedOrder?.products[0]?.price || ''}</span>
              </div>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>{t('YourTownloopOrdersList.Quantity')}:</span>
                <span className={styles['info-value']}>{selectedOrder?.products[0]?.quantity || ''}</span>
              </div>

              <div className={styles['info-row']}>
                <span className={styles['info-label']}>{t('YourTownloopOrdersList.TotalPrice')}:</span>
                <span className={styles['info-value']}>${selectedOrder?.products[0]?.subtotalPrice || ''}</span>
              </div>

              <div className={styles['info-row']}>
                <span className={styles['info-label']}>{t('YourTownloopOrdersList.CreateTime')}:</span>
                <span className={styles['info-value']}>{selectedOrder?.date || ''}</span>
              </div>

              
             
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default YourTownloopOrdersList; 